module.exports = __webpack_public_path__ + "themes/fq/sprite/win-sign@2x.json";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/win-sign@2x.json
// module id = 104
// module chunks = d-game